module.exports = __webpack_public_path__ + "static/img/4.6e299ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/premedical/4.png
// module id = dT9S
// module chunks = 1